import { appUrl } from "../utils/appUrl";
import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { LoginUser } from "../Redux/Actions/Useraction";
import notify from "../Hook/useNotification";
import { validateLogin } from "../Validations/LoginValidation";
import { useTranslation } from "react-i18next";
const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [ispress, setispress] = useState(false);

  const HandelSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateLogin({ email, password, t });
    if (!isValid) return;
    setLoading(true);
    setispress(true);
    await dispatch(
      LoginUser({
        email,
        password,
        role: "admin",
      })
    );
    setLoading(false);
    setispress(false);
  };

  const res = useSelector((state) => state.alluser.loginUser);

  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.token) {
          localStorage.setItem("token", res.token);
          localStorage.setItem("user", JSON.stringify(res.data));
          notify(t("login.success_message"), "success");
          setTimeout(() => {
            window.location.href = appUrl("/");
          }, 1500);
        } else if (res?.data?.message === "Invalid email or password or role") {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          notify(t("login.invalid_credentials"), "error");
        } else if (
          res?.data?.message ===
          "Your email is not verified. We have sent a new verification Link to your email."
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          notify(t("login.email_not_verified"), "error");
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          // notify(,"error")
        }
        setLoading(true);
      }
    }
  }, [loading, res, t]);

  return (
    <Container className=" justify-content-center align-items-center vh-100">
      <div className="text-center mb-4">
        <img
          src={appUrl("/optia.png")}
          alt="Logo"
          style={{ width: "100px", height: "100px", objectFit: "contain" }}
        />
      </div>

      <Row className="w-100 justify-content-center">
        <Col xs={12} md={6} lg={4}>
          <Card className="p-4 shadow rounded-4">
            <Card.Body>
              <h3 className="text-center mb-4">{t("login.title")}</h3>
              <Form onSubmit={HandelSubmit}>
                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label>{t("login.email_label")}</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={t("login.email_placeholder")}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicPassword" className="mb-4">
                  <Form.Label>{t("login.password_label")}</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder={t("login.password_placeholder")}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Group>

                <Button variant="primary" className="w-100" type="submit">
                  {t("login.submit_button")}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {ispress ? (
        loading ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <h4> {t("login.done")} </h4>
        )
      ) : null}
    </Container>
  );
};

export default Login;
